import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ExportDialogImrComponent } from '../../core/components/export-dialog-imr/export-dialog-imr.component';
import { SidenavService } from '../../core/services/sidenav.service';
import { DialogCreateMaintenanceComponent } from './dialogs/dialog-create-maintenance/dialog-create-maintenances.component';
import { MaintenanceFilterState } from './filter/services/maintenance-filter-state.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { defaultColumns } from './maintenances-default-columns';
var MaintenancesComponent = /** @class */ (function () {
    function MaintenancesComponent(matDialog, sidenavService, authenticationService, maintenanceFilterState, fuseTranslationLoaderService) {
        this.matDialog = matDialog;
        this.sidenavService = sidenavService;
        this.authenticationService = authenticationService;
        this.maintenanceFilterState = maintenanceFilterState;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.reloadMaintenances = new Subject();
        this.columns = defaultColumns;
        this.displayedColumns = this.loadColumnsFromStorage();
        this.totalMaintenances = 0;
        this.hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
        this.hasOpenMaintenancePermission = this.authenticationService.hasPermission('maintenances-open') && this.authenticationService.hasAccountPreference({
            property: 'openMaintenance',
            subProperty: 'featureDisableOpenMaintenanceOnPanel',
            expectedValue: false,
            defaultIfUndefined: false
        });
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.filtered = !isEqual(this.maintenanceFilterState.query, this.maintenanceFilterState.defaultQuery);
    }
    MaintenancesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.columns = this.columns.filter(function (column) {
                    return column.flag == null || _this.authenticationService.hasFlags(column.flag);
                });
                this.displayedColumns = this.displayedColumns.filter(function (column) {
                    return _this.columns.some(function (col) { return col.name === column && (col.flag == null || _this.authenticationService.hasFlags(col.flag)); });
                });
                this.maintenanceFilterState.onChangeFilter.pipe(tap(function () {
                    _this.filtered = !isEqual(_this.maintenanceFilterState.query, _this.maintenanceFilterState.defaultQuery);
                })).subscribe();
                return [2 /*return*/];
            });
        });
    };
    MaintenancesComponent.prototype.openDialog = function () {
        var _this = this;
        var maintenancesDialog = this.matDialog.open(DialogCreateMaintenanceComponent, {
            panelClass: 'field-dialog-1200'
        });
        maintenancesDialog.afterClosed().subscribe(function (reload) {
            if (reload) {
                _this.reloadMaintenances.next(reload);
            }
        });
    };
    MaintenancesComponent.prototype.clearFilters = function () {
        this.maintenanceFilterState.query = {};
        this.reloadMaintenances.next(true);
        this.maintenanceFilterState.onClearFilter.next();
    };
    MaintenancesComponent.prototype.updateTotalMaintenances = function (totalMaintenances) {
        this.totalMaintenances = totalMaintenances;
    };
    MaintenancesComponent.prototype.openExportDialog = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.maintenances,
                limit: 50000,
                total: this.totalMaintenances,
                where: this.maintenanceFilterState.query
            }
        });
    };
    MaintenancesComponent.prototype.openExportDialogImr = function () {
        this.matDialog.open(ExportDialogImrComponent, {
            panelClass: 'export-dialog-imr',
            autoFocus: false,
        });
    };
    MaintenancesComponent.prototype.setColumn = function (event, columnName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var displayedColumnsIndex, isSelected;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                event.stopPropagation();
                displayedColumnsIndex = this.displayedColumns.indexOf(columnName);
                isSelected = displayedColumnsIndex > -1;
                if (isSelected && this.displayedColumns.length > 2) {
                    this.displayedColumns.splice(displayedColumnsIndex, 1);
                }
                if (!isSelected) {
                    this.displayedColumns = this.columns
                        .map(function (column) { return column.name; })
                        .filter(function (column) { return column === columnName || _this.displayedColumns.includes(column); });
                }
                localStorage.setItem('maintenances-displayed-columns', JSON.stringify(this.displayedColumns));
                return [2 /*return*/];
            });
        });
    };
    MaintenancesComponent.prototype.parseJson = function (jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch (e) {
            return null;
        }
    };
    MaintenancesComponent.prototype.loadColumnsFromStorage = function () {
        var savedColumnsAsJson = localStorage.getItem('maintenances-displayed-columns');
        var savedColumns = this.parseJson(savedColumnsAsJson);
        if (Array.isArray(savedColumns)) {
            var defaultColumnsNames_1 = this.columns.map(function (column) { return column.name; });
            var savedColumnsFiltered = savedColumns.filter(function (column) { return defaultColumnsNames_1.includes(column); });
            if (savedColumnsFiltered.length) {
                localStorage.setItem('maintenances-displayed-columns', JSON.stringify(savedColumnsFiltered));
                return savedColumnsFiltered;
            }
        }
        var defaultActiveColumnsNames = this.columns.filter(function (column) { return column.active; }).map(function (column) { return column.name; });
        localStorage.setItem('maintenances-displayed-columns', JSON.stringify(defaultActiveColumnsNames));
        return defaultActiveColumnsNames;
    };
    MaintenancesComponent.prototype.ngOnDestroy = function () {
        this.clearFilters();
    };
    return MaintenancesComponent;
}());
export { MaintenancesComponent };
